import script from "./ODadosNaoEncontrados.vue?vue&type=script&lang=ts&setup=true"
export * from "./ODadosNaoEncontrados.vue?vue&type=script&lang=ts&setup=true"

import "./ODadosNaoEncontrados.vue?vue&type=style&index=0&id=4888dad9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4888dad9"]])

export default __exports__